export const analyticsconfig = { // eslint-disable-line
  name: 'analytics-config',
  bind: (el, binding) => {
    const element = el

    if (binding.value.classes) {
      const classes = binding.value.classes
      classes.forEach(c => {
        element.classList.add(c)
      })
    } else {
      console.warn('SEO directive', 'missing classes config.')
    }

    if (binding.value.attrs) {
      const attrs = binding.value.attrs
      attrs.forEach(a => {
        element.setAttributeNode(document.createAttribute(a.name))
        element.setAttribute(a.name, a.value)
      })
    } else {
      console.warn('SEO directive', 'missing Attributes config.')
    }
  }
}
